import { useRef } from "react";
import { useUpdateDescriptionMutation } from "../../../../../../../features/authentication/teacherDocumentApiSlice";
import PropTypes from "prop-types";
import { Form, Button } from "react-bootstrap";
import Modal from "../../../../../../../components/Modal";
import CustomToast from "../../../../../../../components/Toast";

const UpdateDocumentDescriptionModal = ({ showModal, setShowModal, document, setId, onUpdateDescription }) => {
  const [updateDescription, { isLoading: descriptionIsLoading }] = useUpdateDescriptionMutation();
  const descriptionRef = useRef();

  const handleRenameResource = async (e) => {
    e.preventDefault();
    if (document?.description == descriptionRef.current.value) {
      setShowModal(false);
      return;
    }

    const option = {
      documentId: document?.documentId,
      setId: setId,
      description: descriptionRef.current.value
    };

    try {
      const result = await updateDescription(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Name Updated Successfully', 'success');
        setShowModal(false);
        onUpdateDescription();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTitleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 50) {
      event.target.setCustomValidity('Title must not exceed 50 characters!');
    } else {
      event.target.setCustomValidity('');
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      titleName='Rename Document'
      contentWidth='50%'>
      <Form className='d-flex flex-column' onSubmit={(e) => handleRenameResource(e)}>

        <Form.Group id="title" className='w-100'>
          <Form.Label>Title</Form.Label>
          <Form.Control disabled={descriptionIsLoading} type="text" className='w-100' required onInput={handleTitleValidation} defaultValue={document?.description} ref={descriptionRef} />
        </Form.Group>

        <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
          <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
          <Button disabled={descriptionIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{descriptionIsLoading ? 'Saving...' : 'Save'}</Button>
        </div>
      </Form>
    </Modal>
  );
};

UpdateDocumentDescriptionModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  document: PropTypes.object,
  setId: PropTypes.number,
  onUpdateDescription: PropTypes.func
};

export default UpdateDocumentDescriptionModal;